<div class="filter bg-default-inverse-color" [class.active]="selectedOptions.length > 0 || selectedOptions.id"
  (click)="toggleDropdown()"
  #button>
  <div class="name">
    @if (isDisplayName()) {
      {{name}}
    }
    @if (selectedOptions.length > 0) {
      <span class="selected">({{selectedOptions.length}})</span>
    }
    @if (type === 'DATE_RANGE' && selectedOptions.id) {
      @for (dateRangeOption of dateRangeOptions; track dateRangeOption) {
        @if (dateRangeOption.value === selectedOptions.id) {
          <span class="selected">{{dateRangeOption.label | trans}}</span>
        }
      }
    }
  </div>
  @if (selectedOptions.length > 0) {
    <div class="close cl-hint-text-color" (click)="reset()">
      <span aria-hidden="true" class="cm-icon cm-icon-close on-icon-hover"></span>
    </div>
  }
</div>

<div class="filter-dropdown form-group" [class.open]="isOpen" #dropdown>
  @if (isSearchable && type === 'CHECKBOX') {
    <div class="header">
      <div class="form-input-special">
        <input type="text" class="form-control" (input)="search($event)"
          [placeholder]="('General.Search' | trans)"/>
        <span class="input-left icon">
          <span aria-hidden="true" class="cm-icon cm-icon-search"></span>
        </span>
      </div>
    </div>
  }

  <div class="content">
    @if (type === 'CHECKBOX') {
      <app-setting-checkbox-picker [categories]="searchedOptions"
        [(selectedOptions)]="selectedOptions"
        [optionName]="optionLabel"
        [optionKey]="optionValue"
        optionsKey="options"
        categoryName="name"
        columns="1">
      </app-setting-checkbox-picker>
    }

    @if (type === 'DATE_RANGE') {
      <app-form-radio [(value)]="selectedOptions.id" [options]="dateRangeOptions" (valueChange)="radioValueChanged($event)"
      [optionLabelTranslate]="true"></app-form-radio>
      @if (selectedOptions.id === 'CUSTOM') {
        <app-form-datepicker-v3
          [label]="'General.Start_At' | trans"
          [value]="selectedOptions.startAt"
        (change)="onStartDateChange($event)"></app-form-datepicker-v3>
        <app-form-datepicker-v3
          [label]="'General.End_At' | trans"
          [value]="selectedOptions.endAt"
        (change)="onEndDateChange($event)"></app-form-datepicker-v3>
      }
    }

    @if (type === 'EXPIRE_DATE_RANGE') {
      <app-form-radio [(value)]="selectedOptions.id" [options]="expireDateRangeOptions"
      [optionLabelTranslate]="true"></app-form-radio>
      @if (selectedOptions.id === 'CUSTOM') {
        <app-form-datepicker-v3
          [label]="'General.Start_At' | trans"
          [value]="selectedOptions.startAt"
        (change)="onStartDateChange($event)"></app-form-datepicker-v3>
        <app-form-datepicker-v3
          [label]="'General.End_At' | trans"
          [value]="selectedOptions.endAt"
        (change)="onEndDateChange($event)"></app-form-datepicker-v3>
      }
    }
  </div>
</div>

